export default "__VITE_ASSET__CUll4TWa__"